const jobUtils = {
  decodeIfProxy:(raw)=> {
    if (!raw) return null;
    try {
      const MEDIA_MARKER = '/media/';
      const idx = raw.indexOf(MEDIA_MARKER);
      if (idx !== -1) {
        const encodedPart = raw.slice(idx + MEDIA_MARKER.length);
        let decoded = decodeURIComponent(encodedPart.trim());
        if (decoded.startsWith('//')) decoded = 'https:' + decoded;
        if (!/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(decoded)) {
          decoded = decoded.replace(/^(https?:)\/+/, '$1//');
          if (!/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(decoded)) {
            decoded = 'https://' + decoded;
          }
        }
        try {
          new URL(decoded);
          return decoded;
        } catch (_) {
          return decoded;
        }
      }
      return raw.trim();
    } catch (e) {
      return raw;
    }
  },

  timeAgo:(inputDate)=> {
    const then = new Date(inputDate).getTime();
    if (isNaN(then)) return "";
    const now = Date.now();
    const seconds = Math.floor((now - then) / 1000);
    if (seconds < 0) return "just now";
    if (seconds < 45) return "just now";
    if (seconds < 90) return "1 minute ago";
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;
    const days = Math.floor(hours / 24);
    if (days < 7) return `${days} day${days === 1 ? "" : "s"} ago`;
    const weeks = Math.floor(days / 7);
    if (weeks < 4) return `${weeks} week${weeks === 1 ? "" : "s"} ago`;
    const months = Math.floor(days / 30);
    if (months < 12) return `${months} month${months === 1 ? "" : "s"} ago`;
    const years = Math.floor(days / 365);
    return `${years} year${years === 1 ? "" : "s"} ago`;
  }
};

export default jobUtils;
